import { MdChevronRight } from 'react-icons/md';
import { TmdxAvatar } from '@ds';
import type { LocalMessage } from 'stream-chat';
import { CHANNEL_ACTIONS } from '@features/components/Chat/constants';

type PinnedMessagesBannerProps = {
  pinnedMessages: LocalMessage[];
  onOpen: () => void;
};

export const PinnedMessagesBanner = ({ pinnedMessages, onOpen }: PinnedMessagesBannerProps) => {
  if (pinnedMessages.length === 0) return null;

  const firstPinned = pinnedMessages[0];

  return (
    <div className="flex gap-4 px-3 py-1 bg-base-90">
      <div className="flex flex-col w-full relative gap-[2px]">
        <button className="absolute inset-0 z-10" aria-label={CHANNEL_ACTIONS.OPEN_PINNED_PANEL} onClick={onOpen}>
          <span className="sr-only">Open pin messages</span>
        </button>
        <div className="text-info-30 text-s-m flex items-center justify-between w-full gap-1">
          Pinned Messages ({pinnedMessages.length})
          <MdChevronRight size={20} />
        </div>
        <div className="flex items-center gap-1 min-w-0">
          <TmdxAvatar src={firstPinned.user?.image} name={firstPinned.user?.name} fallbackInitials size="sm" />
          <p className="text-s-r text-black min-w-0 overflow-hidden text-ellipsis break-words break-all line-clamp-2 max-w-full">
            {firstPinned.text}
          </p>
        </div>
      </div>
    </div>
  );
};
